import { DirectionalStyleSheetBehavior, display } from "@microsoft/fast-foundation";
import { elevation, neutralForegroundHintBehavior, neutralForegroundRestBehavior, neutralLayerFloatingBehavior, } from "@fluentui/web-components";
import { css } from "@microsoft/fast-element";
const ltr = css `
    li:first-child {
        padding-left: 0;
    }

    li:last-child,
    li.pipe {
        padding-right: 0;
    }

    .pipe::after {
        border-right: 1px solid #cecece;
        padding-left: 18px;
    }
`;
const rtl = css `
    .list {
        padding: 0 0 0 15px;
    }

    li:first-child {
        padding-right: 0;
    }

    li:last-child,
    li.pipe {
        padding-left: 0;
    }

    .pipe::after {
        border-left: 1px solid #cecece;
        padding-right: 18px;
    }
`;
export const FeedNavigationStyles = css `
    ${display("flex")} :host {
        align-items: center;
        color: ${neutralForegroundRestBehavior.var};
        fill: ${neutralForegroundRestBehavior.var};
    }

    .list {
        height: auto;
        overflow: hidden;
        list-style: none;
        padding: 0 15px 0 0;
        margin: 0;
        display: inline-flex;
        align-items: center;
    }

    li {
        list-style: none;
        padding: 0 16px;
        display: flex;
    }

    .hidden {
        visibility: hidden;
    }

    .overflowContainer fluent-button svg {
        vertical-align: middle;
    }

    .overflowContainer .hidden {
        display: none;
    }

    .overflowContainer ul li {
        padding: 5px 0;
        margin: 0 calc((10 + (var(--design-unit) * 2 * var(--density))) * 1px);
    }

    .endContainer {
        display: flex;
        margin-inline-start: auto;
        align-items: center;
    }

    .overflowMenu {
        position: absolute;
        --elevation: 11;
        background: ${neutralLayerFloatingBehavior.var};
        border: calc(var(--outline-width) * 1px) solid transparent;
        border-radius: var(--elevated-corner-radius);
        ${elevation}
        margin: 0;
        padding: 0;
        max-width: 368px;
        min-width: 100px;
        z-index: 3;
    }

    .pipe::after {
        content: "";
        height: 14px;
        align-self: center;
    }
`.withBehaviors(neutralLayerFloatingBehavior, neutralForegroundHintBehavior, neutralForegroundRestBehavior, new DirectionalStyleSheetBehavior(ltr, rtl));
